export default __webpack_public_path__ + "static/media/ai-agents-no-color.c36f2246.svg";